import React, { FC, useContext } from 'react';
import SunnyNav from '@/components/Common/SunnyNav/SunnyNav';
import NavigationBar from '@/components/Common/DesignSystem/NavigationBar/NavigationBar';
import NavigationBarIconButton from '@/components/Common/DesignSystem/NavigationBar/IconButton/NavigationBarIconButton';
import NavigationBarHeading from '@/components/Common/DesignSystem/NavigationBar/Heading/NavigationBarHeading';
import { observer } from 'mobx-react-lite';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { getYaNative } from '@yanolja-rnd/ya-native';
import { forceBackFromExternal } from '@/utils';
import ClickTracker from '@/components/Common/ClickTracker';
import { useRouter } from 'next/router';

const NolPromotionNav: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  const { query } = useRouter();
  return (
    <SunnyNav>
      <>
        <NavigationBar>
          {{
            left: (
              <ClickTracker
                pageName={store.pageName}
                logData={{
                  object: 'backwardBtn',
                  objectType: 'Btn',
                  objectContainer: 'header',
                  motherPageVersion: store.version,
                  motherPageSectionType: '',
                  motherPageSectionName: '야놀자에서 놀때는 NOL 카드',
                  motherPageSectionSubTitle: '',
                  deepLinkUri: '',
                }}
              >
                <NavigationBarIconButton
                  as="button"
                  type="icon_arrowback"
                  onClick={() => {
                    // 진입 경로에 따라 뒤로가기 혹은 웹뷰 닫기를 해야 하는데 현재 정확하게 구분할 수 없음
                    const yaNative = getYaNative();

                    /** 관련티켓: https://jira.yanolja.in/browse/YAFE-837  */
                    if (query?.from === 'order') {
                      history.back();
                    } else {
                      if (yaNative.isEnabled) {
                        history.back();
                      } else {
                        forceBackFromExternal('/');
                      }
                      /**
                       * 웹뷰(place-site 등 다른 도메인)에서 웹뷰(sunny-web)로 넘어왔을경우에는 history가 비어있으므로
                       * history,back을 호출하면 아무동작을 안한다.
                       * 그때는 웹뷰간의 이동이라고 생각하고 네이티브에서 yaNative.dismiss()  실행하도록 한다.
                       * */
                      setTimeout(() => {
                        const yaNative = getYaNative();
                        if (yaNative.isEnabled) {
                          yaNative.dismiss();
                        }
                      }, 1000);
                    }
                  }}
                />
              </ClickTracker>
            ),
            center: <NavigationBarHeading>놀수록 놀라운 혜택 NOL 카드</NavigationBarHeading>,
            right: (
              <ClickTracker
                pageName={store.pageName}
                logData={{
                  object: 'shareBtn',
                  objectType: 'Btn',
                  objectContainer: 'header',
                  motherPageVersion: store.version,
                  motherPageSectionType: 'header',
                  motherPageSectionName: '야놀자에서 놀때는 NOL 카드',
                  motherPageSectionSubTitle: '',
                  deepLinkUri: '',
                }}
              >
                <NavigationBarIconButton
                  as="button"
                  type="icon_share"
                  onClick={() => (store.isShareModalOpen = true)}
                />
              </ClickTracker>
            ),
          }}
        </NavigationBar>
        <NavigationBar.Body>
          <NavigationBar.Shadow />
        </NavigationBar.Body>
      </>
    </SunnyNav>
  );
};

export default observer(NolPromotionNav);
